module.exports = __webpack_public_path__ + "static/media/orange-step.78d39c81.svg";